import { useState } from "react";

import { SubTabs, SubTab } from "components/layout";
import { ReleaseStage } from "hooks/tivoApps";
import { NO_VALUE_PLACEHOLDER } from "src/constants";

import { ReleaseStageTabs } from "../../_shared";
import { DetailsTabProps } from "../types";
import { PresentationConfigSummary } from "./PresentationConfigSummary";
import styles from "./PresentationSection.scss";

export function PresentationsSection({ provider }: DetailsTabProps) {
  const [
    selectedPresentationIndexByStage,
    setSelectedPresentationIndexByStage,
  ] = useState<Record<ReleaseStage, number>>({ rs1: 0, rs2: 0, rs3: 0 });

  return (
    <ReleaseStageTabs className={styles.tabs}>
      {(selectedStage) => {
        const presentationsForSelectedStage = (
          provider.presentations ?? []
        ).filter((item) => item.releaseStage === selectedStage);

        const selectedPresentationIndex = Math.min(
          selectedPresentationIndexByStage[selectedStage],
          presentationsForSelectedStage.length - 1
        );

        const selectedPresentation =
          presentationsForSelectedStage[selectedPresentationIndex] || null;

        return selectedPresentation ? (
          <>
            <SubTabs>
              {presentationsForSelectedStage.map((item, index) => (
                <SubTab
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  active={index === selectedPresentationIndex}
                  text={item.label}
                  onClick={() =>
                    setSelectedPresentationIndexByStage((prev) => ({
                      ...prev,
                      [selectedStage]: index,
                    }))
                  }
                />
              ))}
            </SubTabs>
            <PresentationConfigSummary
              presentation={selectedPresentation}
              selectedStage={selectedStage}
            />
          </>
        ) : (
          NO_VALUE_PLACEHOLDER
        );
      }}
    </ReleaseStageTabs>
  );
}
